package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.alignSelf
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.common.Signature
import io.horion.cv.components.widgets.TextFormField
import io.horion.cv.di.koinGet
import io.horion.cv.styles.ColorDotCheckIconStyle
import io.horion.cv.styles.ColorDotStyle
import io.horion.cv.styles.DeleteButtonStyle
import io.horion.cv.styles.DeleteStyle
import io.horion.cv.styles.DrawingCanvasStyle
import io.horion.cv.styles.EraseButtonStyle
import io.horion.cv.styles.EraseContentSpacingStyle
import io.horion.cv.styles.EraseIconStyle
import io.horion.cv.styles.EraseTextStyle
import io.horion.cv.styles.FinishButtonStyle
import io.horion.cv.styles.FinishButtonTextStyle
import io.horion.cv.styles.FontSelectorArrowStyle
import io.horion.cv.styles.FontSelectorButtonStyle
import io.horion.cv.styles.FontSelectorSpacingStyle
import io.horion.cv.styles.FontSelectorTextStyle
import io.horion.cv.styles.PoliceStyle
import io.horion.cv.styles.SignatureActionsRowStyle
import io.horion.cv.styles.SignatureActionsSpacingStyle
import io.horion.cv.styles.SignatureBoxStyle
import io.horion.cv.styles.SignatureCloseButtonStyle
import io.horion.cv.styles.SignatureCloseIconStyle
import io.horion.cv.styles.SignatureColorsSpacingStyle
import io.horion.cv.styles.SignatureDateInputStyle
import io.horion.cv.styles.SignatureFieldInputStyle
import io.horion.cv.styles.SignatureFieldsDesktopStyle
import io.horion.cv.styles.SignatureFieldsMobileStyle
import io.horion.cv.styles.SignatureLabelStyle
import io.horion.cv.styles.SignatureModalContainerStyle
import io.horion.cv.styles.SignatureModalFirstSpacerStyle
import io.horion.cv.styles.SignatureModalSecondSpacerStyle
import io.horion.cv.styles.SignatureModalTitleStyle
import io.horion.cv.styles.SignaturePlaceholderIconStyle
import io.horion.cv.styles.SignatureTabTextStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Constants.UBUNTU
import kotlinx.browser.document
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.Canvas
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Label
import org.w3c.dom.CENTER
import org.w3c.dom.CanvasLineCap
import org.w3c.dom.CanvasLineJoin
import org.w3c.dom.CanvasRenderingContext2D
import org.w3c.dom.CanvasTextAlign
import org.w3c.dom.CanvasTextBaseline
import org.w3c.dom.HTMLCanvasElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.MIDDLE
import org.w3c.dom.ROUND
import org.w3c.dom.events.Event
import org.w3c.files.FileReader
import org.w3c.files.get

@Composable
fun SignatureForm() {

    var showSignatureModal by remember { mutableStateOf(false) }

    val cvViewModel = koinGet<CvViewModel>()
    val signatureFromVM = cvViewModel.cvUiState.data.signature ?: Signature("", "", "")
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(25.px)
    ) {
        Box(
            modifier = Modifier.fillMaxWidth()
        ) {
            Column(
                modifier = SignatureFieldsMobileStyle.toModifier(),
                verticalArrangement = Arrangement.spacedBy(16.px)
            ) {
                TextFormField(
                    label = "Ville",
                    value = signatureFromVM.city,
                    onValueChange = {
                        cvViewModel.updateSignature(city = it)
                    },
                    modifier = SignatureFieldInputStyle.toModifier()
                )

                FormFieldIcon(
                    label = "Date",
                    value = signatureFromVM.date,
                    onValueChanged = {
                        cvViewModel.updateSignature(date = it)
                    },
                    modifier = SignatureDateInputStyle.toModifier()
                )
            }

            Row(
                modifier = SignatureFieldsDesktopStyle.toModifier(),
                horizontalArrangement = Arrangement.spacedBy(25.px)
            ) {
                Box(
                    modifier = Modifier.weight(1f)
                ) {
                    TextFormField(
                        label = "Ville",
                        value = signatureFromVM.city,
                        onValueChange = {
                            cvViewModel.updateSignature(city = it)
                        },
                        modifier = SignatureFieldInputStyle.toModifier()
                    )
                }

                Box(
                    modifier = Modifier.weight(1f)
                ) {
                    FormFieldIcon(
                        label = "Date",
                        value = signatureFromVM.date,
                        onValueChanged = {
                            cvViewModel.updateSignature(date = it)
                        },
                        modifier = SignatureDateInputStyle.toModifier()
                    )
                }
            }
        }

        Column(
            verticalArrangement = Arrangement.spacedBy(8.px)
        ) {
            SpanText(
                text = "Signature",
                modifier = Modifier
                    .color(if (isDark) Colors.White else Colors.Primary)
                    .then(SignatureLabelStyle.toModifier())
            )

            SignatureField(
                signatureData = signatureFromVM.image.ifEmpty { null },
                onClick = { showSignatureModal = true }
            )
        }

        SignatureModal(
            isOpen = showSignatureModal,
            isClose = { showSignatureModal = false },
            onSave = { data ->
                cvViewModel.updateSignature(image = data)
                showSignatureModal = false
            }
        )
    }
}

@Composable
fun SignatureField(
    signatureData: String?,
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {

    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Box(
        modifier = modifier
            .then(SignatureBoxStyle.toModifier())
            .backgroundColor(if (isDark) Colors.input else Colors.LightGray)
            .onClick { onClick() },
        contentAlignment = Alignment.Center
    ) {
        if (!signatureData.isNullOrEmpty()) {
            Img(
                src = signatureData,
                attrs = Modifier
                    .fillMaxSize()
                    .objectFit(ObjectFit.Contain)
                    .padding(10.px)
                    .toAttrs()
            )
        } else {
            Image(
                src = "/pencil-mark.svg",
                description = "Ajouter une signature",
                modifier = SignaturePlaceholderIconStyle.toModifier()
            )
        }
    }
}

@Composable
fun SignatureModal(
    isOpen: Boolean,
    isClose: () -> Unit,
    onSave: (String) -> Unit
) {
    if (!isOpen) return

    var activeTab by remember { mutableStateOf("draw") }
    var selectedColor by remember { mutableStateOf(Colors.Black) }
    var canvasData by remember { mutableStateOf<String?>(null) }
    var typedText by remember { mutableStateOf("") }
    var selectedFont by remember { mutableStateOf("Dancing Script") }
    var uploadedImage by remember { mutableStateOf<String?>(null) }
    var canvasRef by remember { mutableStateOf<HTMLCanvasElement?>(null) }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .position(Position.Fixed)
            .top(0.px)
            .left(0.px)
            .backgroundColor(Colors.Black.copyf(alpha = 0.4f))
            .zIndex(2000)
            .onClick { isClose() },
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier
                .then(SignatureModalContainerStyle.toModifier())
                .backgroundColor(Colors.White)
                .onClick { it.stopPropagation() }
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                SpanText(
                    "Signature",
                    modifier = SignatureModalTitleStyle.toModifier()
                )

                Box(
                    modifier = DeleteButtonStyle.toModifier()
                        .then(SignatureCloseButtonStyle.toModifier())
                        .onClick { isClose() },
                    contentAlignment = Alignment.Center
                ) {
                    Image(
                        src = "/close.svg",
                        description = "Fermer",
                        modifier = SignatureCloseIconStyle.toModifier()
                    )
                }
            }

            Box(SignatureModalFirstSpacerStyle.toModifier())


            SignatureTabs(
                activeTab = activeTab,
                onTabChange = { activeTab = it }
            )

            Box(Modifier.height(20.px))

            when (activeTab) {
                "draw" -> DrawingCanvas(
                    selectedColor = selectedColor,
                    onDataChange = { canvasData = it },
                    onCanvasReady = { canvasRef = it}

                    )
                "type" -> TypeSignature(
                    text = typedText,
                    onTextChange = { typedText = it },
                    selectedFont = selectedFont
                )
                "upload" -> UploadSignature(
                    imageData = uploadedImage,
                    onImageChange = { uploadedImage = it }
                )
            }

            Box(SignatureModalSecondSpacerStyle.toModifier())


            Row(
                modifier = SignatureActionsRowStyle.toModifier(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Row(
                    modifier = Modifier
                        .then(SignatureActionsSpacingStyle.toModifier()),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(
                        modifier = SignatureColorsSpacingStyle.toModifier()
                    ) {
                        listOf(
                            Colors.Black,
                            Colors.blue,
                            Colors.Red
                        ).forEach { color ->
                            ColorDot(
                                color = color,
                                isSelected = selectedColor == color,
                                onClick = { selectedColor = color }
                            )
                        }
                    }

                    if (activeTab == "draw" && canvasData != null) {
                        Row(
                            modifier = DeleteStyle.toModifier()
                                .then(EraseButtonStyle.toModifier())
                                .then(EraseContentSpacingStyle.toModifier())
                                .background(Colors.White)
                                .onClick {
                                    canvasRef?.let { canvas ->
                                        val ctx =
                                            canvas.getContext("2d") as? CanvasRenderingContext2D

                                        ctx?.clearRect(
                                            0.0,
                                            0.0,
                                            canvas.width.toDouble(),
                                            canvas.height.toDouble()
                                        )
                                    }

                                    canvasData = null
                                },
                            horizontalArrangement = Arrangement.spacedBy(5.px),
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            Image(
                                src = "/eraser-thin.svg",
                                description = "Effacer",
                                modifier = EraseIconStyle.toModifier()
                            )

                            SpanText(
                                text = "Effacer",
                                modifier = EraseTextStyle.toModifier()
                            )
                        }
                    }

                    if (activeTab == "type") {
                        FontSelector(
                            selectedFont = selectedFont,
                            onFontChange = { selectedFont = it }
                        )
                    }
                }

                Button(
                    onClick = {
                        val data = when (activeTab) {
                            "draw" -> canvasData
                            "type" ->
                                if (typedText.isNotEmpty()) {
                                    generateTextSignature(typedText, selectedFont)
                                } else {
                                    null
                                }

                            "upload" -> uploadedImage
                            else -> null
                        }

                        data?.let { onSave(it) }
                    },
                    modifier = FinishButtonStyle.toModifier()
                ) {
                    SpanText(
                        "Terminé",
                        modifier = FinishButtonTextStyle.toModifier()
                    )
                }
            }
        }
    }
}

@Composable
fun SignatureTabs(
    activeTab: String,
    onTabChange: (String) -> Unit
) {

    val tabs = listOf(
        "draw" to "Dessiner",
        "type" to "Taper",
        "upload" to "Télécharger"
    )

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .border(1.px, LineStyle.Solid, Colors.Placeholder)
            .borderRadius(8.px)
            .overflow(Overflow.Hidden)
    ) {
        tabs.forEachIndexed { index, ( id, label ) ->
            Box(
                modifier = Modifier
                    .weight(1f)
                    .padding(topBottom = 20.px)
                    .backgroundColor(
                        if (activeTab == id) Colors.blue else Colors.White
                    )
                    .cursor(Cursor.Pointer)
                    .onClick { onTabChange(id) },
                contentAlignment = Alignment.Center
            ) {
                SpanText(
                    label,
                    modifier = SignatureTabTextStyle.toModifier()
                        .color(
                            if (activeTab == id) Colors.White else Colors.Black
                        )
                        .fontFamily(UBUNTU)
                )
            }
            if (index < tabs.size - 1) {
                Box(
                    modifier = Modifier
                        .width(1.px)
                        .alignSelf(AlignSelf.Stretch)
                        .backgroundColor(Colors.Placeholder)
                )
            }
        }
    }
}

@Composable
fun DrawingCanvas(
    selectedColor: Color,
    onDataChange: (String) -> Unit,
    onCanvasReady: (HTMLCanvasElement) -> Unit
) {
    var canvasRef by remember { mutableStateOf<HTMLCanvasElement?>(null) }

    DisposableEffect(canvasRef, selectedColor) {
        val canvas = canvasRef
        if (canvas == null) return@DisposableEffect onDispose {}

        onCanvasReady(canvas)

        val ctx = canvas.getContext("2d") as CanvasRenderingContext2D
        var lastX = 0.0
        var lastY = 0.0
        var isDrawing = false

        val colorString = when (selectedColor) {
            Colors.Black -> "#000000"
            Colors.blue -> "#173DFF"
            Colors.Red -> "#FF0000"
            else -> "#000000"
        }

        fun getPos(clientX: Double, clientY: Double): Pair<Double, Double> {
            val rect = canvas.getBoundingClientRect()
            return Pair(clientX - rect.left, clientY - rect.top)
        }

        fun draw(x: Double, y: Double) {
            ctx.beginPath()
            ctx.moveTo(lastX, lastY)
            ctx.lineTo(x, y)
            ctx.strokeStyle = colorString
            ctx.lineWidth = 2.0
            ctx.lineCap = CanvasLineCap.ROUND
            ctx.lineJoin = CanvasLineJoin.ROUND
            ctx.stroke()
            lastX = x
            lastY = y
            onDataChange(canvas.toDataURL())
        }

        // Mouse events
        canvas.onmousedown = { event ->
            isDrawing = true
            val (x, y) = getPos(event.clientX.toDouble(), event.clientY.toDouble())
            lastX = x
            lastY = y
        }
        canvas.onmousemove = { event ->
            if (isDrawing) {
                val (x, y) = getPos(event.clientX.toDouble(), event.clientY.toDouble())
                draw(x, y)
            }
        }
        canvas.onmouseup = { isDrawing = false }
        canvas.onmouseleave = { isDrawing = false }

        // Touch events
        val touchStartHandler: (Event) -> Unit = { event ->
            event.preventDefault()
            isDrawing = true
            val touch = event.asDynamic().touches.item(0)
            if (touch != null) {
                val (x, y) = getPos(
                    (touch.clientX as Number).toDouble(),
                    (touch.clientY as Number).toDouble()
                )
                lastX = x
                lastY = y
            }
        }

        val touchMoveHandler: (Event) -> Unit = { event ->
            event.preventDefault()
            if (isDrawing) {
                val touch = event.asDynamic().touches.item(0)
                if (touch != null) {
                    val (x, y) = getPos(
                        (touch.clientX as Number).toDouble(),
                        (touch.clientY as Number).toDouble()
                    )
                    draw(x, y)
                }
            }
        }

        val touchEndHandler: (Event) -> Unit = { _ ->
            isDrawing = false
        }

        canvas.addEventListener("touchstart", touchStartHandler, js("({passive: false})"))
        canvas.addEventListener("touchmove", touchMoveHandler, js("({passive: false})"))
        canvas.addEventListener("touchend", touchEndHandler)

        onDispose {
            canvas.onmousedown = null
            canvas.onmousemove = null
            canvas.onmouseup = null
            canvas.onmouseleave = null
            canvas.removeEventListener("touchstart", touchStartHandler)
            canvas.removeEventListener("touchmove", touchMoveHandler)
            canvas.removeEventListener("touchend", touchEndHandler)
        }
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .then(DrawingCanvasStyle.toModifier())
            .borderRadius(10.px)
            .backgroundColor(Colors.LightGray)
            .overflow(Overflow.Hidden)
    ) {
        Canvas(
            attrs = Modifier
                .fillMaxSize()
                .attrsModifier {
                    attr("width", "650")
                    attr("height", "300")
                    ref {
                        canvasRef = it as HTMLCanvasElement
                        onDispose { }
                    }
                }
                .toAttrs()
        )
    }
}

@Composable
fun TypeSignature(
    text: String,
    onTextChange: (String) -> Unit,
    selectedFont: String
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(300.px)
            .borderRadius(10.px)
            .backgroundColor(Colors.LightGray)
            .padding(20.px)
            .position(Position.Relative),
        contentAlignment = Alignment.Center
    ) {
        if (text.isEmpty()) {
            Box(
                modifier = Modifier
                    .position(Position.Absolute)
                    .top(50.percent)
                    .left(50.percent)
                    .width(2.px)
                    .height(50.px)
                    .backgroundColor(Colors.Black)
                    .attrsModifier {
                        style {
                            property("transform", "translate(-50%, -50%)")
                            property("animation", "blink 1s infinite")
                        }
                    }
            )
        }
        Input(
            type = InputType.Text,
            attrs = Modifier
                .fillMaxWidth()
                .padding(15.px)
                .fontSize(50.px)
                .fontFamily(selectedFont, "cursive")
                .textAlign(TextAlign.Center)
                .border(0.px)
                .backgroundColor(Colors.LightGray)
                .attrsModifier {
                    attr("placeholder", "Signature")
                    attr("value", text)
                    addEventListener("input") { event ->
                        val target = event.target as? HTMLInputElement
                        target?.value?.let { onTextChange(it) }
                    }
                }
                .toAttrs {
                    style {
                        property("outline", "none")
                        property("caret-color", "#000000")
                    }
                }
        )
    }
}

@Composable
fun UploadSignature(
    imageData: String?,
    onImageChange: (String) -> Unit
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .height(300.px)
            .borderRadius(10.px)
            .backgroundColor(Colors.LightGray),
        contentAlignment = Alignment.Center
    ) {
        if (!imageData.isNullOrEmpty()) {
            Img(
                src = imageData,
                attrs = Modifier
                    .fillMaxSize()
                    .objectFit(ObjectFit.Cover)
                    .padding(20.px)
                    .toAttrs()
            )
        } else {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(15.px)
            ) {
                Image(
                    src = "/pencil-mark.svg",
                    description = "upload",
                    modifier = Modifier.size(40.px)
                )
                Label(
                    attrs = Modifier
                        .cursor(Cursor.Pointer)
                        .toAttrs()
                ) {
                    SpanText(
                        "Choisir une image",
                        modifier = Modifier
                            .fontSize(18.px)
                            .color(Colors.blue)
                            .fontFamily(INTER)
                            .textDecorationLine(TextDecorationLine.Underline)
                    )
                    Input(
                        type = InputType.File,
                        attrs = Modifier
                            .display(DisplayStyle.None)
                            .attrsModifier {
                                attr("accept", "image/*")

                                addEventListener("change") { event ->
                                    val input = event.target as? HTMLInputElement
                                    val file = input?.files?.get(0)
                                    file?.let {
                                        val reader = FileReader()
                                        reader.onload = { loadEvent ->
                                            val result = loadEvent.target.asDynamic().result() as String
                                            onImageChange(result)
                                        }
                                        reader.readAsDataURL(it)
                                    }
                                }
                            }
                            .toAttrs()
                    )
                }
            }
        }
    }
}

@Composable
fun FontSelector(
    selectedFont: String,
    onFontChange: (String) -> Unit
) {
    var isOpen by remember { mutableStateOf(false) }

    val fonts = listOf(
        "Dancing Script" to "Signature",
        "Great Vibes" to "Signature",
        "Pacifico" to "Signature",
    )

    Box(
        modifier = Modifier.position(Position.Relative)
    ) {
        Row(
            modifier = PoliceStyle
                .toModifier()
                .then(FontSelectorButtonStyle.toModifier())
                .then(FontSelectorSpacingStyle.toModifier())
                .backgroundColor(Colors.White)
                .onClick { isOpen = !isOpen },
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                "Aa Police de caractères",
                modifier = FontSelectorTextStyle.toModifier()
            )

            Image(
                src = if (isOpen) {
                    "/arrow-up1.svg"
                } else {
                    "/arrow-down1.svg"
                },
                modifier = FontSelectorArrowStyle.toModifier()
            )
        }

        if (isOpen) {
            Column(
                modifier = Modifier
                    .position(Position.Absolute)
                    .top(60.px)
                    .left(0.px)
                    .width(220.px)
                    .backgroundColor(Colors.White)
                    .border(1.px, LineStyle.Solid, Colors.Placeholder)
                    .borderRadius(8.px)
                    .padding(8.px)
                    .zIndex(100)
                    .boxShadow(
                        offsetX = 0.px,
                        offsetY = 1.px,
                        blurRadius = 6.px,
                        spreadRadius = 1.px,
                        color = rgba(0, 0, 0, 0.1)
                    )
            ) {
                fonts.forEach { (fontFamily, text) ->
                    Row(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(12.px)
                            .borderRadius(4.px)
                            .backgroundColor(
                                if (selectedFont == fontFamily) Colors.LightGray else Colors.White
                            )
                            .cursor(Cursor.Pointer)
                            .onClick {
                                onFontChange(fontFamily)
                                isOpen = false
                            },
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.SpaceBetween
                    ) {
                        SpanText(
                            text,
                            modifier = Modifier
                                .fontSize(24.px)
                                .fontFamily(fontFamily, "cursive")
                        )
                        if (selectedFont == fontFamily) {
                            Image(
                                src = "/checkmark1.svg",
                                description = "Sélectionné",
                                modifier = Modifier.size(25.px)
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun ColorDot(
    color: Color,
    isSelected: Boolean,
    onClick: () -> Unit
) {
    Box(
        modifier = ColorDotStyle.toModifier()
            .backgroundColor(color)
            .border(
                width = if (isSelected) 3.px else 0.px,
                style = LineStyle.Solid,
                color = if (isSelected) Colors.Blue else color
            )
            .onClick { onClick() },
        contentAlignment = Alignment.Center
    ) {
        if (isSelected) {
            Image(
                src = "/checkmark2.svg",
                description = "Sélectionné",
                modifier = ColorDotCheckIconStyle.toModifier()
            )
        }
    }
}

fun generateTextSignature(
    text: String,
    fontFamily: String
): String {
    val canvas = document.createElement("canvas") as HTMLCanvasElement
    canvas.width = 650
    canvas.height = 300
    val ctx = canvas.getContext("2d") as CanvasRenderingContext2D
    ctx.font = "48px '$fontFamily', cursive"
    ctx.fillStyle = "#000000"
    ctx.textAlign = CanvasTextAlign.CENTER
    ctx.textBaseline = CanvasTextBaseline.MIDDLE
    ctx.fillText(text, 325.0, 150.0)
    return canvas.toDataURL()
}